// extracted by mini-css-extract-plugin
export default {"description":"SixthScreen_description__6tBT2","title":"SixthScreen_title__10LRi","row":"SixthScreen_row__RvQbz"};